import axios from 'axios';
import { myEpikBaseURL, unifiedBaseURL } from './api';

export const callApi = async ({ isMyEpik, endpoint, method, body }) => {
  const url = `${isMyEpik ? myEpikBaseURL : unifiedBaseURL()}${
    process.env.REACT_APP_UNIFIED_API_VERSION
  }/${endpoint}`;
  const token = localStorage.getItem('jwtToken') || null;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  switch (method) {
    case 'GET':
      return await axios.get(url, {
        headers,
      });
    case 'POST':
      return await axios.post(url, body, {
        headers,
      });
    case 'PUT':
      return await axios.put(url, body, {
        headers,
      });
    case 'PATCH':
      return await axios.patch(url, body, {
        headers,
      });
    case 'DELETE':
      return await axios.delete(url, {
        headers,
      });
    default:
      throw new Error(`Method ${method} is not supported.`);
  }
};
